import getFirebaseApp from './index'
import { getStorage, connectStorageEmulator } from 'firebase/storage'

let st
const storage = () => {
  if (!st) {
    st = getStorage(getFirebaseApp())

    if (location.hostname === 'localhost') {
      connectStorageEmulator(st, 'localhost', 4006)
    }
  }

  return st
}

export default storage
